// Shared "one block per approach road" renderer. Six render sites
// (Property.jsx, EnrichmentStatus.jsx, ListingPreviewModal.jsx,
// PropertyApprovalPage.jsx, and two native screens) used to hand-roll this
// exact markup — a road-label sub-line above the approach text — differing
// only in wrapper/label/text className. Centralizing it here means a markup
// or accessibility fix only needs one edit instead of six.
export default function ApproachesList({
    approaches,
    listClassName = 'flex flex-col gap-2',
    labelClassName = 'text-xs font-semibold text-gray-500 mb-0.5',
    textClassName = 'text-sm text-gray-700 leading-relaxed whitespace-pre-wrap',
}) {
    if (!approaches?.length) return null;

    return (
        <div className={listClassName}>
            {approaches.map((approach, i) => (
                <div key={i}>
                    {approach.roadLabel && (
                        <p className={labelClassName}>From {approach.roadLabel}</p>
                    )}
                    <p className={textClassName}>{approach.text}</p>
                </div>
            ))}
        </div>
    );
}
